import $ from 'jquery'
import Glide from '@glidejs/glide'

$('[data-ekawarnakimia-glide]').each(function() {
    let glide = new Glide(this, $(this).data('ekawarnakimia-glide'))

    glide.on('build.after', function() {
        let $container  = $(glide.selector)
        let $slides     = $container.find('.glide__slides')

        if ($slides.children().length <= glide.settings.perView) {
            glide.disable()
            $container.addClass('disabled')
        } else {
            glide.enable()
            $container.removeClass('disabled')
        }
    })

    glide.mount()
})